import { RenderPayload } from './types';

export const mapTabularRows = (rows: unknown): string[][] => {
  if (!Array.isArray(rows)) {
    return [];
  }

  return rows.map(row => (Array.isArray(row) ? row.map(cell => (cell == null ? '' : String(cell))) : []));
};

export const getRenderPayloadFromFormData = (formData?: Record<string, unknown>): RenderPayload => {
  const fieldsData = Object.entries(formData ?? {}).reduce<RenderPayload['fieldsData']>((acc, [name, value]) => {
    if (name === 'tabular') {
      return acc;
    }

    acc.push({
      name,
      value: String(value ?? ''),
    });
    return acc;
  }, []);

  const tabularData = Object.entries((formData?.tabular as Record<string, unknown> | undefined) ?? {}).reduce<
    RenderPayload['tabularData']
  >((acc, [name, rows]) => {
    acc.push({
      name,
      values: mapTabularRows(rows),
    });
    return acc;
  }, []);

  return { fieldsData, tabularData };
};

export const buildPreviewPayload = ({ fieldsData, tabularData }: RenderPayload): RenderPayload => {
  const filteredFieldsData = fieldsData.reduce<RenderPayload['fieldsData']>((acc, field) => {
    if (String(field.value ?? '').trim() !== '') {
      acc.push(field);
    }
    return acc;
  }, []);

  const filteredTabularData = tabularData.reduce<RenderPayload['tabularData']>((acc, table) => {
    const values = table.values.reduce<string[][]>((rowsAcc, row) => {
      if (row.some(cell => cell.trim() !== '')) {
        rowsAcc.push(row);
      }
      return rowsAcc;
    }, []);

    if (values.length > 0) {
      acc.push({ ...table, values });
    }
    return acc;
  }, []);

  return {
    fieldsData: filteredFieldsData,
    tabularData: filteredTabularData,
  };
};
